(function () {
  var MIN_SCALE = 1;
  var MAX_SCALE = 4;
  var WHEEL_STEP = 0.15;

  function initZoom(modal) {
    if (modal.__ppZoomInit) return;
    modal.__ppZoomInit = true;

    var state = new WeakMap();

    function getState(img) {
      if (!state.has(img)) {
        state.set(img, { scale: 1, x: 0, y: 0 });
      }
      return state.get(img);
    }

    function apply(img) {
      var s = getState(img);
      img.style.transform = 'translate(' + s.x + 'px, ' + s.y + 'px) scale(' + s.scale + ')';
      img.style.cursor = s.scale > 1 ? 'grab' : 'zoom-in';
      img.classList.toggle('pp-zoomed', s.scale > 1);
    }

    function reset(img) {
      state.set(img, { scale: 1, x: 0, y: 0 });
      apply(img);
    }

    function resetAll() {
      modal.querySelectorAll('.pp-modal-item img').forEach(reset);
    }

    function clamp(s) {
      return Math.min(MAX_SCALE, Math.max(MIN_SCALE, s));
    }

    modal.addEventListener(
      'wheel',
      function (e) {
        var img = e.target.closest('.pp-modal-item img');
        if (!img) return;
        e.preventDefault();
        var s = getState(img);
        var prevScale = s.scale;
        s.scale = clamp(s.scale + (e.deltaY < 0 ? WHEEL_STEP : -WHEEL_STEP) * 2);
        if (s.scale === MIN_SCALE) {
          s.x = 0;
          s.y = 0;
        } else {
          var rect = img.getBoundingClientRect();
          var offsetX = e.clientX - rect.left - rect.width / 2;
          var offsetY = e.clientY - rect.top - rect.height / 2;
          var ratio = s.scale / prevScale;
          s.x = (s.x - offsetX) * ratio + offsetX;
          s.y = (s.y - offsetY) * ratio + offsetY;
        }
        apply(img);
      },
      { passive: false }
    );

    var dragging = false;
    var dragImg = null;
    var startX = 0;
    var startY = 0;
    var startImgX = 0;
    var startImgY = 0;

    modal.addEventListener('mousedown', function (e) {
      var img = e.target.closest('.pp-modal-item img');
      if (!img) return;
      var s = getState(img);
      if (s.scale <= 1) return;
      dragging = true;
      dragImg = img;
      startX = e.clientX;
      startY = e.clientY;
      startImgX = s.x;
      startImgY = s.y;
      img.style.cursor = 'grabbing';
      e.preventDefault();
    });

    window.addEventListener('mousemove', function (e) {
      if (!dragging || !dragImg) return;
      var s = getState(dragImg);
      s.x = startImgX + (e.clientX - startX);
      s.y = startImgY + (e.clientY - startY);
      apply(dragImg);
    });

    window.addEventListener('mouseup', function () {
      if (dragImg) dragImg.style.cursor = 'grab';
      dragging = false;
      dragImg = null;
    });

    var clickTimer = null;

    function zoomToPoint(img, clientX, clientY) {
      var s = getState(img);
      var rect = img.getBoundingClientRect();
      var offsetX = clientX - rect.left - rect.width / 2;
      var offsetY = clientY - rect.top - rect.height / 2;
      var newScale = 2.4;
      var ratio = newScale / s.scale;
      s.x = (s.x - offsetX) * ratio + offsetX;
      s.y = (s.y - offsetY) * ratio + offsetY;
      s.scale = newScale;
      apply(img);
    }

    modal.addEventListener('click', function (e) {
      var img = e.target.closest('.pp-modal-item img');
      if (!img) return;
      var s = getState(img);

      if (s.scale > 1) return;

      if (clickTimer) {
        clearTimeout(clickTimer);
        clickTimer = null;
        return;
      }
      var clientX = e.clientX;
      var clientY = e.clientY;
      clickTimer = setTimeout(function () {
        clickTimer = null;
        zoomToPoint(img, clientX, clientY);
      }, 250);
    });

    modal.addEventListener('dblclick', function (e) {
      var img = e.target.closest('.pp-modal-item img');
      if (!img) return;
      if (clickTimer) {
        clearTimeout(clickTimer);
        clickTimer = null;
      }
      reset(img);
    });

    var touchImg = null;
    var lastDist = 0;
    var lastMidX = 0;
    var lastMidY = 0;
    var singleTouchPanning = false;
    var startTouchX = 0;
    var startTouchY = 0;
    var startPanX = 0;
    var startPanY = 0;
    var tapCandidate = null;
    var tapStartX = 0;
    var tapStartY = 0;

    function touchDist(touches) {
      var dx = touches[0].clientX - touches[1].clientX;
      var dy = touches[0].clientY - touches[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function touchMid(touches) {
      return {
        x: (touches[0].clientX + touches[1].clientX) / 2,
        y: (touches[0].clientY + touches[1].clientY) / 2
      };
    }

    modal.addEventListener(
      'touchstart',
      function (e) {
        var img = e.target.closest('.pp-modal-item img');
        if (!img) return;
        var s = getState(img);

        if (e.touches.length === 2) {
          touchImg = img;
          tapCandidate = null;
          var mid = touchMid(e.touches);
          lastDist = touchDist(e.touches);
          lastMidX = mid.x;
          lastMidY = mid.y;
          singleTouchPanning = false;
        } else if (e.touches.length === 1) {
          if (s.scale > 1) {
            touchImg = img;
            singleTouchPanning = true;
            startTouchX = e.touches[0].clientX;
            startTouchY = e.touches[0].clientY;
            startPanX = s.x;
            startPanY = s.y;
            tapCandidate = null;
          } else {
            tapCandidate = img;
            tapStartX = e.touches[0].clientX;
            tapStartY = e.touches[0].clientY;
          }
        }
      },
      { passive: true }
    );

    modal.addEventListener(
      'touchmove',
      function (e) {
        if (tapCandidate && e.touches.length === 1) {
          var dx = e.touches[0].clientX - tapStartX;
          var dy = e.touches[0].clientY - tapStartY;
          if (Math.sqrt(dx * dx + dy * dy) > 10) tapCandidate = null;
        }

        if (!touchImg) return;
        var s = getState(touchImg);

        if (e.touches.length === 2 && lastDist > 0) {
          e.preventDefault();
          var mid = touchMid(e.touches);
          var newDist = touchDist(e.touches);
          var prevScale = s.scale;
          s.scale = clamp(prevScale * (newDist / lastDist));

          var rect = touchImg.getBoundingClientRect();
          var offsetX = mid.x - rect.left - rect.width / 2;
          var offsetY = mid.y - rect.top - rect.height / 2;
          var ratio = s.scale / prevScale;
          s.x = (s.x - offsetX) * ratio + offsetX + (mid.x - lastMidX);
          s.y = (s.y - offsetY) * ratio + offsetY + (mid.y - lastMidY);

          if (s.scale === MIN_SCALE) {
            s.x = 0;
            s.y = 0;
          }
          apply(touchImg);
          lastDist = newDist;
          lastMidX = mid.x;
          lastMidY = mid.y;
        } else if (singleTouchPanning && e.touches.length === 1) {
          e.preventDefault();
          s.x = startPanX + (e.touches[0].clientX - startTouchX);
          s.y = startPanY + (e.touches[0].clientY - startTouchY);
          apply(touchImg);
        }
      },
      { passive: false }
    );

    modal.addEventListener('touchend', function (e) {
      if (tapCandidate && e.touches.length === 0) {
        var img = tapCandidate;
        var s = getState(img);
        var rect = img.getBoundingClientRect();
        var offsetX = tapStartX - rect.left - rect.width / 2;
        var offsetY = tapStartY - rect.top - rect.height / 2;
        var newScale = 2.4;
        var ratio = newScale / s.scale;
        s.x = (s.x - offsetX) * ratio + offsetX;
        s.y = (s.y - offsetY) * ratio + offsetY;
        s.scale = newScale;
        apply(img);
      }
      tapCandidate = null;

      if (e.touches.length === 0) {
        touchImg = null;
        lastDist = 0;
        singleTouchPanning = false;
      }
    });

    modal.addEventListener('click', function (e) {
      if (e.target.closest('.pp-modal-nav, .product-media-modal__toggle')) {
        resetAll();
      }
    });

    var observer = new MutationObserver(function () {
      resetAll();
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['open', 'class'] });
  }

  function init() {
    document.querySelectorAll('.product-media-modal').forEach(initZoom);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
